import { createSlice, createAsyncThunk, isAllOf } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import httpService from '../../common/http.service'

export const appCreateTeams = createAsyncThunk('appTeams/appCreateTeams', async params => {
	try {
		const response = await httpService.post('/team', {}, params)
		if (response?.data) {
			toast.success('Team created Successfully')
		}
		return await response.data
	} catch (error) {
		toast.error(error?.message)
	}
})

export const appAllGetTeams = createAsyncThunk('appTeams/appAllGetTeams', async (params = {}) => {
	try {
		const { userType = 'platform', userId, hub, sanstha, loading = true } = params

		let url = `/team?userType=${encodeURIComponent(userType)}`

		if (userId) url += `&userId=${encodeURIComponent(userId)}`
		if (hub) url += `&hub=${encodeURIComponent(hub)}`
		if (sanstha) url += `&sanstha=${encodeURIComponent(sanstha)}`

		const response = await httpService.get(url, {}, {}, { loading })

		return response.data.data
	} catch (error) {
		toast.error(error?.message || 'Failed to fetch teams')
		throw error
	}
})

export const appUpdateTeamspermission = createAsyncThunk(
	'appTeams/appUpdateTeamspermission',
	async params => {
		try {
			const response = await httpService.put(`/team/${params.teamId}`, {}, params)

			toast.success('Teams is Updated Successfully')
			return {
				...response.data,
				showSuccessPopup: true,
			}
		} catch (error) {
			toast.error(error?.message)
			return {
				showSuccessPopup: false,
			}
		}
	},
)

export const appUpdateTeams = createAsyncThunk('appTeams/appUpdateTeams', async params => {
	try {
		const response = await httpService.put(
			`/team/${params.id}`,
			{},
			{
				email: params.email,
				permissions: params.permissions,
				designation: params.designation,
				sort: params.sort,
				from: params.from,
				to: params.to,
				inactive: params.inactive,
				mobile: params.mobile,
				userId: params.userId,
				sanstha: params.sanstha,
			},
		)

		toast.success('Teams is Updated Successfully')

		return await response.data
	} catch (error) {
		toast.error(error?.message)
	}
})

export const appUpdateDeleteTeams = createAsyncThunk(
	'appTeams/appUpdateDeleteTeams',
	async params => {
		//  console.log(params)
		try {
			const response = await httpService.put(
				`/team/${params.id}`,
				{},
				{
					sanstha: params.sanstha,
					mobile: params.mobile,

					email: params.email,
					permissions: params.permissions,
					designation: params.designation,
					sort: params.sort,
					from: params.from,
					to: params.to,
					inactive: params.inactive,
					userId: params.userId,
				},
			)

			toast.success('Teams is Updated Successfully')

			return await response.data
		} catch (error) {
			toast.error(error?.message)
		}
	},
)

export const appDeleteTeams = createAsyncThunk('appTeams/appDeleteTeams', async id => {
	try {
		const response = await httpService.delete(`/team/${id}`)
		if (response?.data) {
			response.data.id = id
			toast.success('Teams Deleted Successfully')
		}
		return await response.data
	} catch (error) {
		toast.error(error?.message)
	}
})

export const appAllGetPermission = createAsyncThunk(
	'appTeams/appAllGetPermission',
	async userType => {
		try {
			const response = await httpService.get(`/permission?userType=${userType}`)
			return await response.data.data
		} catch (error) {
			toast.error(error?.message)
		}
	},
)

export const appTeamsSlice = createSlice({
	name: 'Teams',
	initialState: {
		teams: [],
		permission: [],
		isloder: false,
		paginate: '',
		isdeleted: false,
	},
	reducers: {},
	extraReducers: builder => {
		builder.addMatcher(isAllOf(appAllGetTeams.pending), (state, action) => {
			state.isloder = true
		})
		builder.addMatcher(isAllOf(appAllGetTeams.fulfilled), (state, action) => {
			state.teams = action.payload
			const paginate = {
				hasNextPage:
					action?.payload?.pagination?.totalPages > action?.payload?.pagination?.currentPage,
				hasPrevPage: action?.payload?.pagination?.currentPage > 1,
				limit: action?.payload?.pagination?.pageSize,
				nextPage: action?.payload?.pagination?.currentPage + 1,
				page: action?.payload?.pagination?.currentPage,
				pagingCounter:
					(action?.payload?.pagination?.currentPage - 1) * action?.payload?.pagination?.pageSize +
					1,
				prevPage: action?.payload?.pagination?.currentPage - 1,
				totalDocs: action?.payload?.pagination?.totalRecords,
				totalPages: action?.payload?.pagination?.totalPages,
			}
			state.paginate = paginate
			state.isloder = false
		})
		builder.addMatcher(isAllOf(appAllGetTeams.rejected), (state, action) => {
			state.isloder = false
		})
		builder.addMatcher(isAllOf(appAllGetPermission.fulfilled), (state, action) => {
			state.permission = action.payload
			state.isloder = false
		})
		builder.addMatcher(isAllOf(appDeleteTeams.pending), (state, action) => {
			state.isloder = true
			state.isdeleted = false
		})
		builder.addMatcher(isAllOf(appDeleteTeams.fulfilled), (state, action) => {
			state.isdeleted = true
			state.teams?.splice(
				state.teams?.findIndex(data => data?._id === action.payload.id),
				1,
			)
			state.isloder = false
		})
		builder.addMatcher(isAllOf(appDeleteTeams.rejected), state => {
			state.isdeleted = false
			state.isloder = false
		})
	},
})

export default appTeamsSlice.reducer
